import React, {useState} from 'react';
import {Flex, Button, Input, PriorityIcon} from '@priority-software/priority-style-react';
import styles from '../styles/templateScreen.module.scss';

const NewContainerInput = props => {
    const [title, setTitle] = useState('');

    const handleNameChange = e => {
        setTitle(e.target.value);
    };

    const onClick = () => {
        const {onClick} = props;
        onClick(title);
        setTitle('');
    };
    const {btntext, placeholder} = props;
    return (
        <Flex>
            <Input
                value={title}
                componentClasses={styles.footerInput}
                size="large"
                placeholder={placeholder}
                onChange={handleNameChange}
            />
            <Button size="medium" darkContainer onClick={onClick} prefixIcon={PriorityIcon.add}>
                {btntext}
            </Button>
        </Flex>
    );
};

export default NewContainerInput;
